import { Lightning as lng } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { Button } from '../../components/shared/Button';
import { ScreenSize } from '../../api/ScreenSize';

/**
 * @param {string} title
 * @param {string} message
 * @param {function} onConfirm
 * @param {function} onCancel
 * @param {string} confirmText
 * @param {string} cancelText
 * @return {{cancelText: string, onCancel: undefined, onConfirm: undefined, confirmText: string, type: ConfirmCancelDialog, title, message}}
 */
export function confirmCancelDialog(
  title,
  message,
  onConfirm = undefined,
  onCancel = undefined,
  confirmText = 'confirm',
  cancelText = 'cancel'
) {
  return {
    type: ConfirmCancelDialog,
    title: title,
    message: message,
    confirmText: confirmText,
    cancelText: cancelText,
    onConfirm,
    onCancel,
  };
}

class ConfirmCancelDialog extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: ScreenSize.w,
      h: h => h,
      rect: true,
      color: Theme.Colors.MessageDialog.Background,

      Dialog: {
        x: w => w / 2,
        y: h => h / 2,
        w: w => w / 3,
        mount: 0.5,
        flex: { direction: 'column' },
        Title: {
          w: ScreenSize.w / 3,
          visible: this.bindProp('title', ctx => !!ctx.title),
          text: {
            text: this.bindProp('title'),
            ...Theme.Fonts.MessageDialog.Title,
          },
        },
        Message: {
          w: ScreenSize.w / 3,
          text: {
            text: this.bindProp('message'),
            ...Theme.Fonts.MessageDialog.Message,
          },
        },
        Buttons: {
          y: 16,
          w: w => w,
          Cancel: {
            w: w => w / 2 - 20,
            type: Button,
            buttonMode: 'dialog',
            h: 60,
            label: this.bindProp('cancelText'),
            signals: {
              onActivate: '_cancel',
            },
          },
          Confirm: {
            x: w => w / 2 + 20,
            w: w => w / 2 - 20,
            type: Button,
            buttonMode: 'dialog',
            h: 60,
            label: this.bindProp('confirmText'),
            signals: {
              onActivate: '_activate',
            },
          },
        },
      },
    };
  }

  _init() {
    this.focusIndex = 1;
  }

  _activate() {
    if (this.onConfirm) {
      this.onConfirm();
    }
    this.fireAncestors('$closeDialog');
  }

  _cancel() {
    if (this.onCancel) {
      this.onCancel();
    }
    this.fireAncestors('$closeDialog');
  }

  _getFocused() {
    return this.tag('Buttons').children[this.focusIndex];
  }

  _handleBack() {
    //do not allow closing the dialog via back
    return true;
  }

  _handleRight() {
    this.focusIndex = 1;
  }

  _handleLeft() {
    this.focusIndex = 0;
  }
}
